import { RootState } from "../reducers"

export const selectUsername = (state: RootState) => state.account.username

export const selectHasModifiedUsername = (state: RootState) =>
  state.account.hasModifiedUsername

export const selectMats = (state: RootState) => state.account.mats

export const selectTotalMats = (state: RootState) =>
  state.account.mats.totalMats

export const selectDailyMats = (state: RootState) =>
  state.account.mats.dailyMats

export const selectContactIdentifiers = (state: RootState) =>
  state.account.contactIdentifiers

export const selectAccountCreationStatus = (state: RootState) =>
  state.account.accountCreationStatus

export const selectLoadingAccountData = (state: RootState) =>
  state.account.loadingAccountData

export const selectUserAuthId = (state: RootState) => state.account.authId
